export default __webpack_public_path__ + "static/media/ZZC_0847.9993509b.jpg";